import { Component, effect, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { WebSettingsService } from 'src/app/services/client/web-settings.service';

@Component({
  selector: 'sb-comp-country-select',
  templateUrl: './sb-country-select.component.html',
  styleUrls: ['./sb-country-select.component.scss'],
  standalone: false,
})
export class SbCountrySelectComponent implements OnInit {
  private readonly webSettingsService = inject(WebSettingsService);
  form: FormGroup;
  countryListIsoCodes: Set<string> = new Set<string>();

  _noValidation: boolean = false;
  @Input() set noValidation(val: boolean) {
    this._noValidation = val;
    if (val) {
      this.form.clearValidators();
      this.form.updateValueAndValidity();
    }
  }

  get noValidation(): boolean {
    return this._noValidation;
  }

  _selectedCountry: string = 'DE';
  @Input() set selectedCountry(val: string) {
    this._selectedCountry = val;
    if (val) {
      if (!this.countryListIsoCodes.has(val)) {
        this.countryListIsoCodes.add(val);
      }
      this.AddressCountry.setValue(val);
      this.AddressCountry.markAsTouched();
    } else {
      this.AddressCountry.setValue('DE');
      this.AddressCountry.markAsTouched();
      this.countrySelectEmitter.emit('DE');
    }
  }

  @Output() countrySelectEmitter: EventEmitter<string>;

  constructor() {
    this.countrySelectEmitter = new EventEmitter<string>();
    this.form = new FormGroup({
      AddressCountry: new FormControl<string>('DE', [Validators.required]),
    });

    effect(() => {
      const settings = this.webSettingsService.settings();
      if (settings?.countryCodesAllowed) {
        const isoCode: string[] = settings.countryCodesAllowed.value.split(',');
        isoCode.forEach(element => {
          this.countryListIsoCodes.add(element.toUpperCase());
        });
        this.AddressCountry.setValue(this._selectedCountry ?? 'DE');
        this.AddressCountry.markAsTouched();
      }
    });
  }

  ngOnInit(): void {
    this.registerFormChangesListener();
  }

  get AddressCountry() {
    return this.form.get('AddressCountry');
  }

  registerFormChangesListener() {
    this.AddressCountry.valueChanges.subscribe(value => {
      this.countrySelectEmitter.emit(value);
    });
  }
}
